import writeXlsxFile from 'write-excel-file';

import type { ParticipantTableItem } from '../types/previdencia/table/participantTableType';

/**
 * Sanitizes a string for use in filename
 */
const sanitizeFileName = (str: string): string => {
  return str.replace(/[^a-zA-Z0-9]/g, '_');
};

/**
 * Generates a filename with current date
 */
const generateFileNameWithDate = (prefix: string, extension: string = 'xlsx'): string => {
  const currentDate = new Date().toISOString().split('T')[0].replace(/-/g, '');
  const sanitizedPrefix = sanitizeFileName(prefix);
  return `${sanitizedPrefix}_${currentDate}.${extension}`;
};

/**
 * Generates an XLSX file for participants and downloads it automatically
 * @param participants - Array of participant data to export
 * @param formatCpf - Optional function to format CPF
 */
export const generateParticipantsXLSX = async (
  participants: ParticipantTableItem[],
  formatCpf?: (cpf: string) => string
): Promise<void> => {
  if (!participants || participants.length === 0) {
    return;
  }

  // Define columns
  const columns = [
    { value: 'Nome do Participante', width: 30 },
    { value: 'CPF', width: 15 },
    { value: 'Número de Matrícula', width: 20 },
    { value: 'Número do Contrato', width: 20 },
    { value: 'Empresa', width: 25 },
  ];

  // Prepare data rows
  const data = participants.map((participant) => [
    { type: String, value: participant.participantName || '' },
    { type: String, value: formatCpf ? formatCpf(participant.cpf) : participant.cpf || '' },
    { type: String, value: participant.registrationNumber || '' },
    { type: String, value: participant.contractNumber || '' },
    { type: String, value: participant.companyName || '' },
  ]);

  // Write file and trigger download
  await writeXlsxFile([columns, ...data], {
    fileName: generateFileNameWithDate('Participantes'),
  });
};

